<template>
  <div>
    <NuxtLayout name="resource" :item="item">
      <template #content>
        <YouTubeVideo
          v-if="item?.youtube_id"
          :item="item"
        />
      </template>
    </NuxtLayout>
  </div>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})
</script>
